import { Trans } from '@lingui/macro';
import { Link } from 'react-router-dom';
import { Input } from '@economic/taco';

interface Props {
    setAlreadyOnboardedId: (alreadyOnboardedId: string) => void;
}

export default function AlreadyOnboarded({ setAlreadyOnboardedId }: Props) {
    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const string = inputValue.trim();
        setAlreadyOnboardedId(string);
    };

    return (
        <>
            <div className="text-center mt-4">
                <h2>
                    <Trans>Oops! Already connected.</Trans>
                </h2>
            </div>
            <div className="mb-4 mt-2">
                <Trans>It looks like you already have an active Rackbeat agreement with this agreement number or CVR.</Trans>
            </div>
            <div className="mt-2">
                <h4>
                    <Trans>Your Options:</Trans>
                </h4>
            </div>
            <div className="mt-2">
                <h5>
                    <Trans>Link agreements:</Trans>
                </h5>
                <div className="ml-5">
                    <ol className="mb-1" style={{ listStyleType: 'decimal' }}>
                        <li>
                            <Trans>Log in to Rackbeat</Trans>
                        </li>
                        <li>
                            <Trans>Go to Settings - General - Advanced</Trans>
                        </li>
                        <li>
                            <Trans>Click the "Generate Connection ID" button</Trans>
                        </li>
                        <li>
                            <Trans>Paste the Connection ID below</Trans>
                        </li>
                        <li>
                            <Trans>Click Next</Trans>
                        </li>
                    </ol>
                </div>
                <div className="mb-5 w-1/2">
                    <Input onChange={onInputChange} />
                </div>
            </div>
            <div className="mt-2">
                <h5>
                    <Trans>Cancel current agreement:</Trans>
                </h5>
                <div className="ml-5">
                    <ol style={{ listStyleType: 'decimal' }}>
                        <li>
                            <Trans>Log in to Rackbeat</Trans>
                        </li>
                        <li>
                            <Trans>Cancel your current agreement.</Trans>
                        </li>
                        <li>
                            <Trans>Restart the process.</Trans>
                        </li>
                    </ol>
                </div>
            </div>

            <div className="mb-4 mt-2">
                <Trans>
                    Need Help? Contact <Link to="https://rackbeat.com/kontakt/">support</Link>.
                </Trans>
            </div>
        </>
    );
}
